"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _LoadSVG = _interopRequireDefault(require("../../../../components/LoadSVG"));

var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ActiveSegmentPanel = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ActiveSegmentPanel, _React$Component);

  function ActiveSegmentPanel() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ActiveSegmentPanel.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        superSegment = _this$props.superSegment,
        persona = _this$props.persona;
    var activeSegment = undefined;

    if (superSegment && persona) {
      activeSegment = superSegment.segments.find(function (item) {
        return parseInt(item.id) === parseInt(persona);
      });
    }

    return /*#__PURE__*/React.createElement("div", {
      className: "active-persona-panel"
    }, /*#__PURE__*/React.createElement("div", {
      className: "active-persona-panel__content"
    }, /*#__PURE__*/React.createElement("div", {
      className: "active-persona-panel__title"
    }, /*#__PURE__*/React.createElement("span", null, activeSegment && activeSegment.id), /*#__PURE__*/React.createElement("span", {
      className: "active-persona-panel__community-title"
    }, superSegment.id, " ", superSegment.label)), /*#__PURE__*/React.createElement("div", {
      className: "active-persona-tile__name"
    }, activeSegment && activeSegment.label), /*#__PURE__*/React.createElement("div", {
      className: "active-persona-tile__stats-container"
    }, /*#__PURE__*/React.createElement("span", {
      className: "active-persona-tile-stat"
    }, /*#__PURE__*/React.createElement("span", {
      className: "active-persona-tile-stat__icon"
    }, activeSegment && activeSegment.acf.excerptIcon1 && /*#__PURE__*/React.createElement(_LoadSVG["default"], {
      src: activeSegment.acf.excerptIcon1.image.url,
      colour: activeSegment.color
    })), activeSegment && activeSegment.acf.excerptNumberOnLeft1 && /*#__PURE__*/React.createElement("span", {
      className: "active-persona-panel__figure"
    }, activeSegment && activeSegment.acf.excerptValue1, ' ', activeSegment && activeSegment.acf.excerptLabel1), activeSegment && !activeSegment.acf.excerptNumberOnLeft1 && /*#__PURE__*/React.createElement("span", {
      className: "active-persona-panel__figure"
    }, activeSegment && activeSegment.acf.excerptLabel1, ' ', activeSegment && activeSegment.acf.excerptValue1)), /*#__PURE__*/React.createElement("span", {
      className: "active-persona-tile-stat"
    }, /*#__PURE__*/React.createElement("span", {
      className: "active-persona-tile-stat__icon"
    }, activeSegment && activeSegment.acf.excerptIcon2 && /*#__PURE__*/React.createElement(_LoadSVG["default"], {
      src: activeSegment && activeSegment.acf.excerptIcon2.image.url,
      colour: activeSegment && activeSegment.color
    })), activeSegment && activeSegment.acf.excerptNumberOnLeft2 && /*#__PURE__*/React.createElement("span", {
      className: "active-persona-panel__figure"
    }, activeSegment && activeSegment.acf.excerptValue2, ' ', activeSegment && activeSegment.acf.excerptLabel2), activeSegment && !activeSegment.acf.excerptNumberOnLeft2 && /*#__PURE__*/React.createElement("span", {
      className: "active-persona-panel__figure"
    }, activeSegment && activeSegment.acf.excerptLabel2, ' ', activeSegment && activeSegment.acf.excerptValue2))), (0, _htmlReactParser["default"])(activeSegment && activeSegment.acf.summaryExcerpt)), /*#__PURE__*/React.createElement("div", {
      className: "active-persona-panel__images"
    }, activeSegment && activeSegment.knowMeGallery && activeSegment.knowMeGallery.map(function (image, key) {
      return /*#__PURE__*/React.createElement("div", {
        className: "active-persona-panel__image",
        key: key
      }, /*#__PURE__*/React.createElement(_LoadSVG["default"], {
        src: image.sizes.medium
      }));
    })));
  };

  return ActiveSegmentPanel;
}(React.Component);

var _default = ActiveSegmentPanel;
exports["default"] = _default;